import { getAcceptOfferUrl, getCreateOfferUrl, getDeclineOfferUrl, getOfferUrl, getReceivedOffersUrl, getSentOffersUrl } from "../endpoints/offerEndpoints";
import { useMutation, useQuery, useQueryClient } from "react-query";
import useAxios from "../../hooks/useAxios";

export const useGetOffer = (id) => {
    const client = useAxios();
    return useQuery(['getOffer', id], () => {
        return client.get(getOfferUrl(id));
    });
};

export const useGetSentOffers = (id) => {
    const client = useAxios();
    return useQuery('getSentOffers', () => {
        return client.get(getSentOffersUrl(id));
    });
};

export const useGetReceivedOffers = (id) => {
    const client = useAxios();
    return useQuery('getReceivedOffers', () => {
        return client.get(getReceivedOffersUrl(id));
    });
};

export const useCreateOffer = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((body) => {
        return client.put(getCreateOfferUrl(), body);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getSentOffers');
        }
    });
};

export const useAcceptOffer = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.patch(getAcceptOfferUrl(id));
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getReceivedOffers');
        }
    });
};

export const useDeclineOffer = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.patch(getDeclineOfferUrl(id));
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getReceivedOffers');
        }
    });
};

export const useCancelOffer = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.delete(getOfferUrl(id));
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('getSentOffers');
        }
    });
};